// Banda de intro de pantalla (`.subtitle-bar` del mock): responde "¿qué estoy viendo aquí?" en
// una línea italic bajo el topbar. La usan casi todas las pantallas del backoffice.
import type { ReactNode } from 'react';

export function PageIntro({ children }: { children: ReactNode }) {
    return (
        <div className="border-b border-border bg-muted/30 px-3 py-1.5 text-[11px] italic leading-relaxed text-muted-foreground">
            {children}
        </div>
    );
}
